// extracted by mini-css-extract-plugin
module.exports = {"boxBreadcrumb":"SDP-ZH9N2UdqGCVSllSGW","item":"_2OuMICuKGJlcL3imFDhB_k","label":"_3WdGoY0yTzMo1Zgt468bko"};